<template>
  <header class="g-hd">
    <b-container class="bv-example-row g-h100">
      <b-navbar class="g-h100" toggleable="lg" type="dark" fixed="bottom" :sticky="true">
        <b-navbar-brand>
          <router-link to="home">
            <div role="logo" class="m-logo">
              <svg-icon class="u-logo-icon" icon-class="haodalogo"/>
            </div>
          </router-link>
        </b-navbar-brand>

        <b-navbar-toggle target="nav_collapse"/>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto m-nav" v-if="!isSearchOpen" style="position: relative;">
            <template v-for="item in routes">
              <template v-if="item.meta.isShowNav" v-for="items in item.children">
                <b-nav-item :class="$route.name == items.name?'z-crt':''" @click="$router.push(items.path)">{{items.meta.title}}</b-nav-item>
              </template>
            </template>
          </b-navbar-nav>

          <!-- <b-nav-form v-if="isSearchOpen" class="m-search  ml-auto">
            <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search" @blur.prevent="changeCount()"/>
            <b-button size="sm" class="my-2 my-sm-0" type="submit">
              <img class="u-img" src="../../assets/img/img_search.png" alt="">
            </b-button>
          </b-nav-form>
          <b-button v-if="!isSearchOpen" size="lg" variant="primary" @click="isSearchOpen = !isSearchOpen" class="m-btn">
            <img class="u-img" src="../../assets/img/img_search.png" alt="">
          </b-button> -->
        </b-collapse>
      </b-navbar>
    </b-container>
  </header>
</template>

<script>
export default {
  name: "headBar",
  components: {},
  props: {
    config: {}
  },
  data() {
    return {
      isSearchOpen: false
    };
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    }
  },
  methods:{
     changeCount:function(){
       alert:0
      },

  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/z-0.6.less";
@import "../../assets/css/variables.less";
.g-hd {
  background: linear-gradient(0deg, rgba(3, 40, 67, 1), rgba(0, 30, 56, 1));
  .m-main {
    .pos(r);
    width: @viewWidth;
    .marginAuto();
  }

  .m-logo {
    .pos(r);
    width: 150px;
    height: 58px;
    .u-logo-icon {
      .pos(a);
      top: 50%;
      transform: translateY(-50%);
      font-size: 150px;
    }
    overflow: hidden;
  }

  .m-nav {
    .nav-item {
      .pos(r);      
      padding-left: 1rem;
      padding-right: 1rem;
      a {
        color: #fff;
      }
      &:hover,
      &.z-crt {
        a {
          color:@mainColor;
        }
      }
      &:last-child {
        &:after {
          .dn();
        }
      }
      &:after {
        content: "/";
        .pos(a);
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        color: #19517c;
      }
    }
  }
  .navbar-dark .navbar-toggler {
    border: none;
  }

  .btn-lg{
    padding: 0.15rem 0.5rem;
  }
  .btn{
    height: 40px;
  }
  .u-img{
    padding-bottom: 5px;
  }
  
  .form-control-sm{
    height: 40px;
    line-height: 40px;
  }


  @media (max-width: 992px) {
    .m-logo {
      .pos(r);
      width: 100px;
      height: 24px;
      .u-logo-icon {
        font-size: 90px;
      }
    }
    .m-nav {
      .nav-item {
        &:after {
          .dn();
        }
      }
    }
    
    .form-control-sm{
      width: 80%;
      margin-right: 5px;
    }    
    .m-btn{
      .fr();
    }
  }
}
.navbar{
  .pos(r)!important;  
}
@media (max-width: 992px) {
  .navbar{
    padding: 0.5rem 0rem;
  }
  .navbar-toggler{
    padding: 0.25rem 0rem;
  }
  .navbar-collapse{
    .pos(a);
    .tc();
    width: calc(~'100% + 30px');
    left: -15px;
    top: 54px;
    background: linear-gradient(0deg, rgba(3, 40, 67, 0.95), rgba(0, 30, 56,0.95)); 
  }
  
}  
@media (min-width: 768px) and (max-width:900px){
  .container {
      max-width: 768px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/headbar/index.vue